import { OrderEditUserDataInput } from '@graphql/graphql-types';

export class UpdateOrderUserData {
  static readonly type = '[Reservation] Update Order User Data';
  constructor(public orderUserData: OrderEditUserDataInput | null) {}
}
